import { DataBox } from './DataBox'
import { baseVehicleModel } from '../vehicleModel'
import { PageHeader } from './PageHeader'
import { AddVehicleModal } from './addVehicleModal'
import { EditVehicleModal } from './editVehicleModal'

export function BaseVehicle() {
    const { addCarVisible, editCarVisible } = baseVehicleModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddVehicleModal />}
            {editCarVisible && <EditVehicleModal />}
        </>
    )
}
